// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TreatsDetailModal_modalOverlay__eCnQ9","modalContent":"TreatsDetailModal_modalContent__xQNe1","closeButton":"TreatsDetailModal_closeButton__4xUwv"};